(function () {
    // I don't want to deal with the RequireJS bullshit. Just return the configs.
    var module = {
        config: function () {
            return config;
        }
    };